import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="/assets/logo/city-battery-horizontal.svg" 
                alt="city-battery.energy" 
                className="h-[26px] sm:h-[32px] w-auto"
              />
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-sm text-slate-600 hover:text-cyan-700 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Zurück zur Startseite</span>
              <span className="sm:hidden">Zurück</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl sm:text-4xl font-semibold text-slate-800 mb-8">Datenschutzerklärung</h1>
          
          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">1. Allgemeine Hinweise</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie darüber, welche Daten wir erheben, wie wir diese nutzen und welche Rechte Sie in Bezug auf Ihre Daten haben.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">2. Verantwortlicher gemäß Art. 4 Abs. 7 DSGVO</h2>
            <p className="text-slate-600 leading-relaxed">
              <strong>DSG Beteiligungs- und Verwaltungsgesellschaft mbH</strong><br /><br />
              <strong>Telefon:</strong><br />
              Mobil: <a href="tel:+4917693127245" className="text-cyan-700 hover:text-cyan-800">+49 176 93127245</a><br />
              Festnetz: <a href="tel:+493071047955" className="text-cyan-700 hover:text-cyan-800">+49 30 71047955</a><br /><br />
              <strong>E-Mail:</strong> <a href="mailto:it@city-battery.energy" className="text-cyan-700 hover:text-cyan-800">it@city-battery.energy</a>
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">3. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck der Verarbeitung</h2>
            
            <h3 className="text-lg font-semibold text-slate-800 mb-3">3.1 Beim Besuch der Website</h3>
            <p className="text-slate-600 leading-relaxed mb-4">
              Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an unseren Server gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Folgende Daten können dabei erfasst werden:</strong>
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
              <li>IP-Adresse des anfragenden Geräts</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Name und URL der abgerufenen Datei</li>
              <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
              <li>verwendeter Browser und ggf. das Betriebssystem Ihres Endgeräts</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Diese Daten werden zu folgenden Zwecken verarbeitet:</strong>
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
              <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
              <li>Auswertung der Systemsicherheit und -stabilität</li>
              <li>administrative Zwecke</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 S. 1 lit. f DSGVO.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Hosting erfolgt bei:</strong><br />
              STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin, Deutschland.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Mit dem Hostinganbieter besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-3 mt-6">3.2 Nutzung des Kontaktformulars</h3>
            <p className="text-slate-600 leading-relaxed mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular (Name, Firma, E-Mail-Adresse, Telefonnummer und Nachricht) zur Bearbeitung der Anfrage und für mögliche Anschlussfragen gespeichert.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
            </p>
            <p className="text-slate-600 leading-relaxed">
              Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-3 mt-6">3.3 Cookies</h3>
            <p className="text-slate-600 leading-relaxed">
              Unsere Website verwendet ausschließlich technisch notwendige Cookies.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">4. Weitergabe von Daten</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Eine Übermittlung Ihrer persönlichen Daten an Dritte findet grundsätzlich nicht statt, außer wenn:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-1">
              <li>Sie Ihre ausdrückliche Einwilligung erteilt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
              <li>eine rechtliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
              <li>die Verarbeitung zur Vertragserfüllung erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">5. Ihre Rechte als betroffene Person</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Sie haben folgende Rechte:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
              <li>Auskunft (Art. 15 DSGVO)</li>
              <li>Berichtigung (Art. 16 DSGVO)</li>
              <li>Löschung (Art. 17 DSGVO)</li>
              <li>Einschränkung (Art. 18 DSGVO)</li>
              <li>Widerspruch (Art. 21 DSGVO)</li>
              <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">
              <strong>Widerruf der Einwilligung:</strong> jederzeit möglich.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Sie haben außerdem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">6. Speicherdauer</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">7. Datensicherheit</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir setzen geeignete technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust oder unbefugten Zugriff zu schützen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">8. Änderungen dieser Datenschutzerklärung</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren.
            </p>
          </section>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-slate-100 border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">© 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik</p>
            <div className="flex gap-6">
              <Link to="/impressum" className="text-sm text-slate-500 hover:text-cyan-700">Impressum</Link>
              <Link to="/datenschutz" className="text-sm text-slate-500 hover:text-cyan-700">Datenschutz</Link>
              <Link to="/barrierefreiheit" className="text-sm text-slate-500 hover:text-cyan-700">Barrierefreiheit</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DatenschutzPage;
